/**
 * We use this dummy class to produce a type signature
 */
declare global {
  interface Window {
    yotpoWidgetsContainer?: {
      initWidgets: () => void
    }
  }
}

export const refreshYotpoWidget = (): void => {
  const wc = window.yotpoWidgetsContainer
  if (wc && typeof wc.initWidgets === 'function') {
    wc.initWidgets()
  } else {
    console.warn(
      'Yotpo SPA API (yotpoWidgetsContainer.initWidgets) not found'
    )
  }
}
